import React from 'react';

function Exchange() {
  return (
    <div>
      <h3>XML Terms Of Service</h3>
       <p>
          This AGREEMENT (“Agreement”) which comprises the full and complete 
          agreement of the Parties hereto and supersedes all previous 
          agreements between the Parties relating to the subject matter 
          hereof, is entered into by and between 1902063 Ontario Ltd. O/A 
          JobAdX, 240-2155 Leanne Boulevard, Mississauga, ON, L5K2L6 for 
          itself and wholly owned subsidiaries (“Provider”), and you (
          “Publisher”). Provider and Publisher are sometimes referred to 
          hereinafter as a “Part” or collectively “Parties”. 
        </p>
        <p>
          WHEREAS, Provider is engaged in the business of selling job 
          advertisements and paying for their distribution for its own account, 
          and for the joint account of itself and others, and in course of such 
          operations, regularly and customarily enters into contracts with 
          Publisher for the growth of Providers publisher network. Publishers 
          are job boards, associations etc. and have a direct relationship with 
          job seekers. 
        </p>
        <p>
          Now, THEREFORE, in consideration of the mutual promises and 
          agreements contained herein, the sufficiency of which is hereby 
          acknowledged, the Parties mutually agree as follow: 
        </p>
        <ol>
          <li>
            This Agreement shall be effective as of the date first written above and thereupon shall remain in force and effect until 
            terminated by either Party by giving the other Party (48) hours prior written notice. This agreement shall control and govern all 
            Services performed by the Publisher or the Provider, under subsequent oral or written work orders, purchase orders or other 
            similar documents issued or accepted by Provider (“Campaign Setup Agreement”). Any agreements or stipulations in any such campaign 
            setup agreement or other instrument used by Publisher not in conformity with their terms and provisions of this Agreement, or 
            that purport to add to the rights of Publisher or to restrict the right of Provider Group, shall be null and void. No waiver, 
            modification or amendment of any of the terms, provisions, or conditions herein shall be effective unless said waiver, 
            modification and amendments is in writing and signed by an authorized representative of the Provider and The Publisher.
          </li>
          <li>
            Provider has full autonomy on the actual billing numbers in relation to the number of clicks / applicants spent on 
            job-advertisement buys and that the Provider is the authority on the amount of the clicks spent on the Publisher Site. The 
            Publisher must reconcile click numbers and applicant numbers to match those collected by the Provider on a per-day basis to 
            ensure that accuracy is met on the Publishers dashboard, with 
            respect to the use of internal or 3rd party software. The click 
            spending data in real-time is not 100% reconciled, however click spending data from the previous day is accurate, as long as the 
            reconciliation process of the previous day has been completed by the Provider. 
          </li>
          <li>
            Provider will pay the Publisher in 60 days’ net from the end of the month. 
          </li>
          <li>
            Provider and Publisher will work on integration and allocate required resources for the implementation. 
          </li>
          <li>
            Click Definitions are as follows: 
            <ul>
              <li>
                Expired Clicks: Clicks are considered expired if the job is 
                no longer available within JobAdX’s network/job inventory. 
                The source feed has been refreshed and no longer includes 
                that job.
              </li>
              <li>
                Duplicate Clicks: Every click is a valid click, without restriction.
              </li>
              <li>
                Bot/or Fraudulent Clicks: JobAdX uses a Third Party service 
                called “ipqualityscore” to determine click fraud and bot 
                clicks. These clicks will be discounted from the total as per 
                the Third Party decision. 
              </li>
              <li>
                Expired Latent Clicks: Clicks are considered expired if the 
                job is no longer available, as reported by the Advertiser. 
                The Advertiser has removed the job however the source feed 
                has not yet been updated in our job inventory. 
              </li>
              <li>
                Foreign Clicks: Clicks from IP addresses originating outside of the United States will be discounted. 
              </li>
            </ul>
          </li>
          <li>
          Provider will not be required to pay out the Publisher for clicks deemed by the click tracking technology as fraudulent or bot clicks.
          </li>
          <li>
            THIS AGREEMENT SHALL BE GOVERNED, CONSTRUED AND INTERPRETED IN 
            ACCORDANCE WITH THE GENERAL LAW OF PROVINCE OF ONTARIO, CANADA, 
            EXCEPT AS OTHERWISE PROVIDED IN THIS AGREEMENT.
          </li>
          <li>
            Notwithstanding any provisions herein to the contrary, upon the 
            termination of this Agreement for any reason whatsoever, the 
            provisions of this agreement which by their nature require some 
            action for forbearance after such termination, including but not 
            limited to those related to indemnities, warranties, 
            confidentiality and insurance, shall survive such termination and 
            be binding until any actions, obligations and/or rights therein 
            provided have been satisfied or released. 
          </li>
          <li>
            It shall be conclusively presumed that each and every provision 
            of this Agreement was drafted jointly by the Parties hereto. A 
            waiver by either Party of any one or more defaults by the other 
            hereunder shall not operate as a waiver of any other existing or 
            future default or defaults, whether of a like or different 
            character. 
          </li>
          <li>
            Both Parties agree that this Agreement complies with the 
            requirements, known as the express negligence and conspicuousness 
            rules, to expressly state in a conspicuous manner to afford fair 
            and adequate notice that this Master Service Agreement has 
            Provisions requiring one Party (the indemnitor) to be responsible 
            for the negligence, strict liability, or other fault of another 
            person or entity (the indemnitee). Both Parties represent to each 
            other that (a) they have consulted an attorney concerning this 
            Master Service Agreement, if they have not consulted an attorney, 
            that they were provided the opportunity and had the ability to so 
            consult, but made an informed decision not to do so, and (b) they 
            fully understand their rights and obligations under this Master 
            Service Agreement.
          </li>
        </ol>
        <p>
          IN WITHNESS WHEROF, the duly authorized representatives of the Parties hereto have executed this Agreement to be effective from 
          the first day of the campaign as confirmed by both Parties.
        </p>
    </div>
  );
}

export default Exchange;
